import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import 'react-datepicker/dist/react-datepicker.css'

import { Row, Column } from "../../components/Layout";
import HereMap from "../../components/Map/HereMap";
import NTMTable from "../../components/Table/NTMTable";
import PageWithModal from "../../components/Page/PageWithModal";
import Image from "../../components/Image";
import EditLabelModal from "../../components/Modal/EditLabelModal";
import BuildingModal from "../../components/Modal/BuildingModal";
import NTMButton from "../../components/Buttons/NTMButton";
import AssignDevicePanel from "../Dashboard/AssignDevicePanel";
import { getStatus, changeBadgeLabel, changeCardLabel, saveBuilding, disassociateBuilding, disassociateCard, updateBuildingBadges, updateProjectBadges, clearAction } from "redux/badge/badgeActions";
import { addIcon_top, addIcon_topOver, deleteIcon, deleteIcon_over, editIcon, editIcon_over, pinIcon } from 'img/icons'
import style from "../Dashboard/style.module.scss"
import Roles from "constants/Roles"


const LABEL_BADGE = 1
const LABEL_CARD = 2
const FROM_PROJECT = 3
const FROM_BUILDING = 4

export default function BadgeDashboard() {
	const dispatch = useDispatch();

	const badges = useSelector(store => store.badge.badges)
	const buildings = useSelector(store => store.badge.buildings)
	const cards = useSelector(store => store.badge.cards)
	const unassigned = useSelector(store => store.badge.unassigned)
	const error = useSelector(store => store.badge.error)
	const loading = useSelector(store => store.badge.loading)
	const success = useSelector(store => store.badge.success)
	const project = useSelector(store => store.session.project)
	const user = useSelector(store => store.users.data)

	const [buildingEdit, setBuildingEdit] = useState()
	const [buildingModal, setBuildingModal] = useState(false)
	const [confirmModal, setConfirmModal] = useState()
	const [labelEdit, setLabelEdit] = useState()

	useEffect(() => { dispatch(getStatus(project.id)) }, [dispatch, project.id])

	let changeLabel = useCallback((label) => {
		if (labelEdit.type === LABEL_BADGE) {
			dispatch(changeBadgeLabel(project.id, labelEdit.id, label))
		}
		else if (labelEdit.type === LABEL_CARD) {
			dispatch(changeCardLabel(project.id, labelEdit.id, label))
		}
		setLabelEdit(null)
	}, [dispatch, project.id, labelEdit])

	let disassociateBadge = useCallback((device, from) => {
		let devices
		let buildingId = device.buildingId
		if (buildingId) {
			devices = badges.filter(d => d.buildingId === buildingId && d.deviceId !== device.deviceId).map(d => d.deviceId)
			dispatch(updateBuildingBadges(project.id, buildingId, devices))
		}
		if (from === FROM_PROJECT) {
			devices = badges.filter(d => d.deviceId !== device.deviceId).map(d => d.deviceId)
			dispatch(updateProjectBadges(project.id, devices))
		}
	}, [dispatch, project.id, badges])

	let devicePopUp = useCallback((name, devices) =>
		`<div class="bubble">
			<div class="name">nome edificio</div><div>${name}</div>
			<div class="name">dispositivi</div><div>${devices.map(d => d.label || d.deviceId).join(", ")}</div>
		</div>`, [])

	let clear = () => {
		dispatch(clearAction())
		setConfirmModal(null)
	}

	let markers = [];
	let center = {
		lat: 40.967320,
		lng: 17.115670
	};

	buildings.forEach(k => {
		if (k.lat && k.lng) markers.push({
			lat: k.lat,
			lng: k.lng,
			data: devicePopUp(k.name, k.devices),
			icon: pinIcon
		});
	});

	if (markers && markers.length > 0) {
		center = { lat: markers[0].lat, lng: markers[0].lng };
	}

	return (
		<PageWithModal
			loading={loading}
			error={error}
			success={success}
			confirm={confirmModal}
			clear={clear}
		>
			<Row className={style.box}>
				<HereMap
					center={center}
					zoom={10}
					theme={"normal.day"}
					markers={markers}
					className={style.map}
				/>
			</Row>
			{Roles.isAdmin(user) && <Row>
				<NTMButton
					onClick={() => setBuildingModal(true)}>
					<Image
						src={addIcon_top}
						hover={addIcon_topOver} />
					AGGIUNGI
				</NTMButton>
			</Row>}
			<Row className={style.box}>
				<NTMTable
					title="EDIFICI"
					header={[
						{
							Header: "NOME",
							accessor: 'name',
							filterable: true,
							Cell: props =>
								<Row className={style.deviceRow} >
									<span>{props.original.name}</span>
									<div>
										<Image
											src={editIcon}
											hover={editIcon_over}
											onClick={() => {
												setBuildingEdit(props.original)
												setBuildingModal(true)
											}}
										/>
										&nbsp;&nbsp;
										<Image
											src={deleteIcon}
											hover={deleteIcon_over}
											onClick={() => setConfirmModal({
												message: 'Eliminazione edifico',
												onConfirm: () => dispatch(disassociateBuilding(project.id, props.original.id)),
											})}
										/>
									</div>
								</Row>
						},
						{
							Header: "INDIRIZZO",
							accessor: 'address',
							filterable: true
						},
						{
							Header: "CITTA'",
							accessor: 'city',
							filterable: true
						},
						{
							Header: "DISPOSITIVI",
							accessor: 'devices',
							Cell: props => <div>{props.original.devices.map(d =>
								<Row key={d.id} className={style.deviceRow}  >
									<span>{d.label || d.deviceId}</span>
									{Roles.isAdmin(user) && <div>
										<Image
											src={editIcon}
											hover={editIcon_over}
											onClick={() => setLabelEdit({ type: LABEL_BADGE, id: d.deviceId })}
										/>
										&nbsp;&nbsp;
										<Image
											src={deleteIcon}
											hover={deleteIcon_over}
											onClick={() => setConfirmModal({
												message: "Rimozione lettore dall'edificio",
												onConfirm: () => disassociateBadge(d, FROM_BUILDING),
											})}
										/>
									</div>}
								</Row>)}
							</div>
						},
						{
							Cell: props =>
								<Link
									to={{
										pathname: `/buildingaccess/${props.original.id}`
									}}
									className={style.link}
								>
									{"Visualizza accessi"}
								</Link>
						}
					]}
					body={buildings}
				/>
			</Row>
			<Row className={style.box}>
				<NTMTable
					title="TESSERE"
					header={[
						{
							Header: "CARD ID",
							accessor: 'id',
							filterable: true,
							Cell: props =>
								<Row className={style.deviceRow}>
									<span>{props.original.id}</span>
									{Roles.isAdmin(user) && <Image
										src={deleteIcon}
										hover={deleteIcon_over}
										onClick={() => setConfirmModal({
											message: 'Eliminazione tessera',
											onConfirm: () => dispatch(disassociateCard(project.id, props.original.id)),
										})}
									/>}
								</Row>
						},
						{
							Header: "LABEL",
							accessor: 'name',
							filterable: true,
							Cell: props =>
								<Row className={style.deviceRow}>
									<span>{props.original.name}</span>
									{Roles.isAdmin(user) && <Image
										src={editIcon}
										hover={editIcon_over}
										onClick={() => setLabelEdit({ type: LABEL_CARD, id: props.original.id })}
									/>}
								</Row>
						},
						{
							Header: "ULTIMA RILEVAZIONE",
							accessor: 'updated_at',
							Cell: props => <div>
								{props.original.updated_at ? new Date(props.original.updated_at).toLocaleString('it-IT') : '-'}
							</div>
						},
						{
							Cell: props =>
								<Link
									to={{
										pathname: `/cardaccess/${props.original.id}`
									}}
									className={style.link}
								>
									{"Visualizza accessi"}
								</Link>
						}
					]}
					body={cards}
				/>
			</Row>
			<Row className={style.box}>
				<NTMTable
					title="LETTORI"
					header={[
						{
							Header: "ID",
							accessor: 'deviceId',
							Cell: props =>
								<Column>
									<Row className={style.deviceRow}>
										<span>{props.original.deviceId}</span>
									</Row>
									{Roles.isSuperUser(user) && <Row className={style.deviceRow}>
										<NTMButton primary onClick={() => disassociateBadge(props.original, FROM_PROJECT)}>Rimuovi</NTMButton>
									</Row>}
								</Column>
						},
						{
							Header: "NOME",
							accessor: 'label',
							Cell: props =>
								<Row className={style.deviceRow}>
									<span>{props.original.label}</span>
									{Roles.isAdmin(user) && <Image
										src={editIcon}
										hover={editIcon_over}
										onClick={() => setLabelEdit({ type: LABEL_BADGE, id: props.original.deviceId })}
									/>}
								</Row>
						},
						{
							Header: "ULTIMO CONTATTO",
							accessor: 'updated_at',
							Cell: props =>
								<div>
									{props.original.updated_at ? new Date(props.original.updated_at).toLocaleString('it-IT') : '-'}
								</div>
						},
						{
							Header: "BATTERIA",
							accessor: 'battery',
							Cell: props =>
								<span style={{ alignItems: "center" }}>
									{`${+props.original.battery} V`}
								</span>
						},
					]}
					body={badges}
				/>
			</Row>
			{Roles.isSuperUser(user) &&
				<AssignDevicePanel devices={badges.map(d => d.deviceId)} onSave={() => dispatch(getStatus(project.id))} />
			}

			<EditLabelModal
				isOpen={!!labelEdit}
				onClose={() => setLabelEdit(null)}
				onSubmit={changeLabel}
			/>
			<BuildingModal
				building={buildingEdit}
				unassigned={unassigned}
				isOpen={buildingModal}
				onClose={() => {
					setBuildingModal(false)
					setBuildingEdit(null)
				}}
				onSubmit={building => {
					setBuildingModal(false)
					setBuildingEdit(null)
					dispatch(saveBuilding(project.id, building))
				}}
			/>
		</PageWithModal>
	);
}
